// Выбор клиента с поиском
import { Button, Divider, Select } from "antd";
import { useMemo, useState } from "react";
import debounce from 'lodash/debounce';
import { serverFetch } from "../../server";
import { PlusOutlined } from "@ant-design/icons";
import Client from "../../components/clients/client";
import { isMobile } from '../../extensions/design';

const debounceTimeout = 300;

/** Поля формы нового клиента с экрана родителя (имя / телефон / почта). */
const normalizeNewClientSeed = (getter) => {
  if (typeof getter !== "function") return null;
  try {
    const raw = getter();
    if (!raw || typeof raw !== "object") return null;
    const patch = {};
    const name = raw.name != null ? String(raw.name).trim() : "";
    const phone = raw.phone != null ? String(raw.phone).trim() : "";
    const email = raw.email != null ? String(raw.email).trim() : "";
    if (name) patch.name = name;
    if (phone) patch.phone = phone;
    if (email) patch.email = email;
    return Object.keys(patch).length ? patch : null;
  } catch {
    return null;
  }
};

const SelectClient = ({
  onClear,
  onChange,
  value,
  placeholder,
  defOptions,
  style = {},
  className = "",
  getInitialNewClientFields,
  disabled = false,
}) => {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const [newClientSeed, setNewClientSeed] = useState(null);

  const debounceFetcher = useMemo(() => {
    const loadOptions = value => {
      setOptions([]);
      setFetching(true);
      serverFetch(`client?searchText=${encodeURIComponent(value)}&limit=10&showdeleted=false`)
        .then(data => {
          setOptions(data.map(i => ({label: `${i.name} ${i.phone}`, value: i.id})));
          setFetching(false);
        })
    };
    return debounce(loadOptions, debounceTimeout);
  }, []);

  const popupRender = menu => {
    return <>
      {menu}
      <Divider style={{ margin: '8px 0' }} />
      <Button type="text" icon={<PlusOutlined />} onClick={() => {
        setNewClientSeed(normalizeNewClientSeed(getInitialNewClientFields));
        setId(0);
        setOpen(false);
      }}>Новый клиент</Button>
    </>
  }

  const onCloseAdd = (res, value, label) => {
    setId(null);
    setNewClientSeed(null);
    onChange({value, label})
  }

  return<>
    <Select 
      placeholder={placeholder}
      disabled={disabled}
      onSearch={debounceFetcher}
      filterOption={false}
      showSearch
      options={options.length ? options : defOptions}
      loading={fetching}
      value={value}
      onChange={e => e && onChange(options.find(i => i.value === e))}
      onClear={onClear}
      allowClear
      popupRender={popupRender}
      open={open}
      className={isMobile ? className : ""}
      style={style}
      onDropdownVisibleChange={setOpen}
    />
    {id !== null && <Client id={id} onClose={onCloseAdd} initialFields={id === 0 ? newClientSeed : undefined}/>}
  </>
}

export default SelectClient;